import { useEffect } from 'react';

import { useEffectOnce } from 'react-use';

import { useStores } from '../../../stores/useStores';

export function useGamesSeen(listener: () => void) {
  const { categoriesStore } = useStores();

  const { categoriesIds, loading } = categoriesStore;
  const isLoading = loading.get('categories');

  useEffectOnce(() => {
    window.addEventListener('scroll', listener);
    return () => {
      window.removeEventListener('scroll', listener);
    };
  });

  useEffect(() => {
    if (!isLoading && categoriesIds.length > 0) {
      setTimeout(listener, 300);
    }
  }, [listener, isLoading, categoriesIds, categoriesStore.currentId]);
}
